module.exports = __webpack_public_path__ + "static/media/03.c65a96de.png";